<app-navbar-user></app-navbar-user>
<div class="container-fluid login mb-5 main-content" *ngIf="userData">
  <div class="row">
    <div class="col-lg-4 offset-lg-4 col-sm-6 offset-sm-3">
      <div class="card bg-white shadow px-3 pb-3">
        <div class="card-body">
          <h1>Update Details</h1>
          <div class="alert alert-danger" *ngIf="error">
            <p>{{ error }}</p>
          </div>
          <div *ngIf="isLoading" class="text-center">
            <app-loading-spinner></app-loading-spinner>
          </div>
          <form
            #authForm="ngForm"
            (ngSubmit)="onSubmit(authForm)"
            *ngIf="!updated"
            class="standard-form"
            name="update-details"
          >
            <div class="form-group mb-2">
              <label for="firstName">First Name</label>
              <input
                type="text"
                id="firstName"
                class="form-control"
                [ngModel]="userData.first_name"
                name="firstName"
                placeholder="First Name"
                required
              />
            </div>
            <div class="form-group mb-2">
              <label for="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                class="form-control"
                [ngModel]="userData.last_name"
                name="lastName"
                placeholder="Last Name"
                required
              />
            </div>
    
            <div class="form-group mb-2">
              <label for="email">Email</label>
              <input
                type="email"
                id="email"
                class="form-control"
                [ngModel]="userData.email"
                name="email"
                placeholder="Email"
                required
                email
              />
            </div>
    
            <div class="form-group">
              <button
                type="submit"
                [disabled]="!authForm.valid || isLoading"
                class="btn btn-dark rounded-pill w-100"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>